import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const tracfoneSubs = resourceReducer('tracfoneSubs', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default tracfoneSubs;

export const getAllTracfoneSubs = (state, page = 1) =>
  getResources(state, `page${page}`);
export const getAllUserTracfoneSubs = (state, userId) =>
  getResources(state, `userTracfoneSubs${userId}`);
export const getCreatedTracfoneSub = (state) =>
  state.requests.create &&
  state.requests.create.status === 'SUCCEEDED' &&
  state.resources[state.requests.create.ids[0]];
export const getTracfonePortResponse = (state, subId) =>
  state.requests[`updatePort${subId}`];
export const getTracfonePortInfo = (state, subId) =>
  state.meta[subId] && state.meta[subId].portInfo;
export const getTracfonePortStatusResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].portStatus;
export const getTracfoneUpdateStatusResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].updateStatus;
export const getTracfoneDeviceDetails = (state) =>
  state.requests.updateDevice && state.requests.updateDevice.details;
export const getTracfoneActivationResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].activation;
export const getTracfoneSub = (state, id) => state.resources[id];
export const getTracfoneSubNotFound = (state, id) =>
  state.meta[id] && state.meta[id].readStatusCode === 404;
export const getTracfoneSubServiceCodes = (state, subId) =>
  state.meta[subId] && state.meta[subId].serviceCodes;
export const getTracfoneSubDetailsInfo = (state, subId) =>
  state.meta[subId] && state.meta[subId].detailsInfo;
export const getUserTracfoneSubs = (state) => getResources(state, 'userSubs');
export const getFilteredTracfoneSubs = (state, filter, page) =>
  getResources(state, `${filter}Subs${page}`);
export const getSearchTracfoneSubs = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getTracfoneFilteredSubs = (state, requestKey) =>
  getResources(state, requestKey);
export const getTracfoneFilteredSubsCount = (state, requestKey) =>
  state.requests[requestKey] && state.requests[requestKey].count;
export const getAllTracfoneSubsCount = (state, page) =>
  state.requests[`fetchTracfoneByUser${page}`] &&
  state.requests[`fetchTracfoneByUser${page}`].count;
export const getTracfoneSubNotFoundFromFind = (state) =>
  Boolean(
    state.requests &&
      state.requests.find &&
      state.requests.find.statusCode === 404,
  );
export const getTracfoneSubDataUsage = (state, subId) =>
  state.meta[subId] && state.meta[subId].dataUsage;
export const getAllTracfoneInitialsSubs = (state) =>
  getResources(state, `allTracfoneInitialsSubs`);
export const getAllTracfoneInitialsSubsStatus = (state) =>
  state.requests.fetchAllTracfoneInitialsSubs &&
  state.requests.fetchAllTracfoneInitialsSubs.status;
export const getTracfoneSubServiceCodesError = (state, subId) =>
  state.meta[subId] && state.meta[subId].serviceCodesError;
